import {Map, fromJS, List} from "immutable";

import {
    FETCH_USERS_REQUEST, FETCH_USERS_SUCCESS, FETCH_USERS_ERROR,
    FETCH_USER_REQUEST, FETCH_USER_SUCCESS, FETCH_USER_ERROR,
    CREATE_USER_REQUEST, CREATE_USER_SUCCESS, CREATE_USER_ERROR,
    SEND_WELCOME_USER_REQUEST, SEND_WELCOME_USER_SUCCESS, SEND_WELCOME_USER_ERROR,
    UPDATE_USER_REQUEST, UPDATE_USER_SUCCESS, UPDATE_USER_ERROR,
    UPDATE_USER_STATUS_REQUEST, UPDATE_USER_STATUS_SUCCESS, UPDATE_USER_STATUS_ERROR,
    DELETE_USER_REQUEST, DELETE_USER_SUCCESS, DELETE_USER_ERROR
} from "./users-action";

const users = (state = Map({
    payload: List([]),
    isFetching: false,
    error: false
}), action) => {
    let newState;
    let updatedPayload, index, payload = state.get("payload");
    switch (action.type) {

        // Requests
        case FETCH_USERS_REQUEST:
        case FETCH_USER_REQUEST:
        case CREATE_USER_REQUEST:
        case SEND_WELCOME_USER_REQUEST:
        case UPDATE_USER_REQUEST:
        case UPDATE_USER_STATUS_REQUEST:
        case DELETE_USER_REQUEST:
            newState = state.remove("errorMessage").merge({
                isFetching: true,
                error: false,
                updated: false
            });
            return newState;

        // Success
        case FETCH_USERS_SUCCESS:
        case FETCH_USER_SUCCESS:
            newState = state.merge({
                payload: fromJS(action.payload),
                isFetching: false,
                error: false
            });
            return newState;

        case CREATE_USER_SUCCESS:
            if (List.isList(state.get("payload"))) {
                let updatedPayload = state.get("payload");
                updatedPayload = updatedPayload.push(fromJS(action.payload));

                newState = state.merge({
                    payload: updatedPayload,
                    isFetching: false,
                    error: false
                });
            } else {
                newState = state.merge({
                    payload: fromJS(action.payload),
                    isFetching: false,
                    error: false
                });
            }
            return newState;

        case UPDATE_USER_SUCCESS:
        case UPDATE_USER_STATUS_SUCCESS:
        case SEND_WELCOME_USER_SUCCESS:

            // let updatedPayload, index, payload = state.get("payload");

            // Check if payload is a List
            if (List.isList(state.get("payload"))) {

                // Find the index of the user to be updated inside the List
                index = payload.findIndex(item => {
                    return item.get('_id') === action.payload._id;
                });

                // Update the payload list
                if (index !== -1) {
                    updatedPayload = payload.update(index, () => {
                       return fromJS(action.payload);
                    });
                }

                // If payload is a Map the payload to be updated is action.payload itself
            } else {
                updatedPayload = fromJS(action.payload);
            }
            newState = state.remove("errorMessage").merge({
                isFetching: action.isFetching,
                error: false,
                payload: updatedPayload,
                updated: true
            });
            return newState;

        case DELETE_USER_SUCCESS:

            updatedPayload = state.get('payload').filter( user => {
                return user.get('_id') !== action.payload._id;
            });
            newState = state.merge({
                payload: updatedPayload,
                isFetching: action.isFetching,
                error: action.error
            });
            return newState;

        // Errors
        case FETCH_USERS_ERROR:
        case FETCH_USER_ERROR:
        case CREATE_USER_ERROR:
        case UPDATE_USER_ERROR:
        case UPDATE_USER_STATUS_ERROR:
        case SEND_WELCOME_USER_ERROR:
        case DELETE_USER_ERROR:
            newState = state.merge({
                isFetching: false,
                error: action.error,
                errorMessage: action.errorMessage
            });
            return newState;
        default:
            return state;
    }
};

export default users;